import axios from "axios";

const actions = {
  async signIn({ commit, dispatch }, authData) {
    try {
      const { data } = await axios.post("/users/sign_in", authData);
      commit("SET_CURRENT_USER", data);
    } catch (error) {
      throw error;
    }
  },

  signOut({ commit }) {
    axios.delete("/users/sign_out").then(() => {
      window.location.href = "/users/sign_in";
      commit("CLEAR_CURRENT_USER");
    });
  },

  async fetchProfile({ commit }) {
    try {
      const { data } = await axios.get("/api/profile");
      commit("SET_CURRENT_USER", data);
    } catch (error) {
      throw error;
    }
  },

  setReferrer({ commit }, data) {
    commit("SET_REFERRER", data);
  }
};

export default actions;
